export default {
    // 用户的增删改查
    login: "/api/user/login.json", //登陆

    logout: "/api/user/outLogin.json", //登出

    showUser: "/api/user/showUser.json", //用户展示

    addUser: "/api/user/addUser.json", //添加用户

    updateUser: "/api/user/updateUser.json", //修改用户信息

    delUser: "/api/user/delUser.json", //批量删除用户

    updatePassword: "/api/user/updatePassword.json", //修改密码

    //组织
    upDateOrganization: "/api/organization/upDateOrganization.json", //修改组织信息

    delOrganization: "/api/organization/delOrganization.json", //删除组织信息

    getOrganization: "/api/organization/getOrganization.json", //查找单个组织信息

    addOrganization: "/api/organization/addOrganization.json", //添加组织

    getOTree: "/api/organization/getOTree.json", //组织信息展示

    //设备
    updateVehicle: "/api/vehicle/updateVehicle.json", //修改车辆信息

    delVehicle: "/api/vehicle/delVehicle.json", //删除设备信息

    getVehiclesByOId: "/api/vehicle/getVehiclesByOId.json", // 根据组织获取设备信息

    addVehicle: "/api/vehicle/addVehicle.json", //添加设备信息

    removeVehicle: "/api/vehicle/removeVehicle.json", //车辆转移

    getVehicleDetali: "/api/vehicle/getVehicleByVid.json", // 获取设备详情

    getMonitor: "/api/vehicle/getMonitor.json", //获取当前查询数据页数

    //批量导出
    doWriteExcelUser: "/api/user/doWriteExcelUser.json", //用户批量导出

    writeExcelVehicle: "/api/vehicle/writeExcelVehicle.json", // 设备批量导入

    getVehicleByL: "/api/vehicle/getVehicleByL.json", //模糊查询

    //监控中心
    getVehicleState: "/api/monitoringCenterController/getVehicleState.json", //根据组织展示电池设备状态

    getPosInfo: "/api/monitor/getPosInfo.json", //获取气泡数据（最后位置相关数据）

    getMonitorInfo: "/api/monitor/getMonitorInfo.json", //电池监控信息

    getElectricCurve: "/api/monitor/getElectricCurve.json", // 电流曲线

    //首页
    getAlarms: "/api/home/getAlarms.json", //报警加载

    getHomePageInfo: "/api/home/getHomePageInfo.json", //首页统计

    getSevenDayOnOfflineInfo: "/api/home/getSevenDayOnOfflineInfo.json", //统计7日在线离线休眠数目

    getCurveInfo: "/api/home/getCurveInfo.json", //统计充放电曲线

    getCalculatAlarmInfo: "/api/home/getCalculatAlarmInfo.json", //故障数目统计

    getComonInfo: "/api/home/getComonInfo.json", //一般状态统计

    getBaseAndTodayInfo: "/api/home/getBaseAndTodayInfo.json", //基本信息与当日统计

    getMockPileWarnPileInfo: "/api/monitor/getMockPileWarnPileInfo.json", //模拟量告警量面板-GPRS-XINGHENG

    getMockPileWarnPileInfoBetter: "/api/monitor/getMockPileWarnPileInfoBetter.json", //电池详情-GPRS-BETTER

    commandDown: "/api/cmd/commandDown.json", //控制下发

    getOnOfflineReport: "/api/report/getOnOfflineReport.json", //离线报表

    getRealtimeAlarmReport: "/api/report/getRealtimeAlarmReport.json", //实时报表

    getCommandReport: "/api/report/getCommandReport.json", //指令报表

    getBmsTrack: "/api/track/getBmsTrack.json", //电池记录

    getPosTrack: "/api/track/getPosTrack.json", //轨迹查询

    getOnOfflineInfo: "/api/home/getOnOfflineInfo.json", //获取当前在线、离线、休眠数目

    //设备续费
    queryMyState: "/recharge/log/queryMyState.json", //更新用户信息

    queryVehicleExpire: "/recharge/log/queryVehicleExpire.json", //获取续费列表

    queryVehicleFreeLog: "/recharge/log/queryVehicleFreeLog.json", //查询车辆续费记录

    giveUserRecharge: "/recharge/log/giveUserRecharge.json", //对下级用户做货币划拨

    queryRechargeLog: "/recharge/log/queryRechargeLog.json", //查询用户币划拨记录

    getChargeAndGive: "/currency/log/getChargeAndGive.json", //充值or赠送（总账号）

    getQueryChargeLog: "/currency/log/getQueryChargeLog.json", //查询充值记录（总账号）

    vehicleRecharge: "/recharge/log/vehicleRecharge.json",//用户对车辆续费

    batchRecharge: "/recharge/log/batchRecharge.json", //批量续费

    doDownVehFile: "/recharge/log/doDownVehFile.json", //获取车辆续费操作文档

    getAllRegoinInfo: "/api/monitor/getAllRegoinInfo.json", //获取地域信息

    getBmsTrackDetail: "/api/track/getBmsTrackDetail.json", //报表中心查看详情数据

    importVehicleExcel:'/api/vehicle/importVehicleExcel.json',//导入车辆excel表-批量添加设备

    getVehicleImportTemp:'/api/vehicle/getVehicleImportTemp.json',//查询校验的结果-批量添加设备

    clearImportTemp:'/api/vehicle/clearImportTemp.json',//清除数据库缓存信息-批量添加设备

    updateErrorInfo:'/api/vehicle/updateErrorInfo.json',//修改并校验错误结果(返回修改信息)-批量添加设备

    batchAddVehicle:'/api/vehicle/batchAddVehicle.json',//提交录入车辆-批量添加设备

    writePosExcel:'/api/excel/writePosExcel.json',//导出位置信息报表

    writeBmsSourceExcel:'/api/excel/writeBmsSourceExcel.json',//导出bms电池原始信息

    pageUpgradeFiles:'/upgradeFiles/pageUpgradeFiles',//分页获取远程升级文件列表

    addUpgradeFiles:'/upgradeFiles/addUpgradeFiles',//新增远程升级文件

    deleteUpgradeFiles:'/upgradeFiles/deleteUpgradeFiles',//删除远程升级文件

    getUpgradeFiles:'/upgradeFiles/getUpgradeFiles',//获取指令下发远程升级所需要的文件

    pageRemoteUpgradeLog:'/remoteUpgradeLog/pageRemoteUpgradeLog',//分页获取远程升级日志

    pageBindDriverInfo:'/driver/pageBindDriverInfo',//获取绑定司机信息

    instructionIssuanceRemoteUpgrade:'/api/cmd/instructionIssuanceRemoteUpgrade',//达锂-远程升级

    instructionIssuanceReadRegister:'/api/cmd/instructionIssuanceReadRegister',//达锂-读寄存器

    instructionIssuanceWriteRegister:'/api/cmd/instructionIssuanceWriteRegister',//达锂-写单个寄存器

    instructionIssuanceBatchWriteRegister:'/api/cmd/instructionIssuanceBatchWriteRegister',//达锂-写多个单个寄存器

    queryProtectiveBoardData:'/api/cmd/queryProtectiveBoardData',//读寄存器-查询保护板数据

    queryHistoricalFaultInformation:'/api/cmd/queryHistoricalFaultInformation',//读寄存器-查询设备历史故障信息

    getDeviceRealBMSData:'/api/monitor/getDeviceRealBMSData',//获取达锂设备实时BMS数据（保护板数据）

    deviceUnbind:'/driver/deviceUnbind',//设备解绑

    pageUserRoleLog:'/userRoleLog/pageUserRoleLog',//分页查询权限变更记录

    getBinddeviceInfo:'/driver/getBinddeviceInfo',//获取绑定设备信息

    pageAlarmReport:'/alarm/pageAlarmReport',//分页历史报警明细

    exportAlarmReport:'/alarm/exportAlarmReport',//导出历史报警明细

    exportDeviceRealBMSData:'/api/monitor/exportDeviceRealBMSData',//导出达锂设备实时BMS数据

    listPathInfo:'/safetyZone/listPathInfo',//获取用户下的所有重点区域信息

    deletePathInfo:'/safetyZone/deletePathInfo',//删除重点区域

    updateAreaEnable:'/safetyZone/updateAreaEnable',//变更区域启用状态

    addPathInfo:'/safetyZone/addPathInfo',//新增重点区域信息

    updatePathInfo:'/safetyZone/updatePathInfo',//修改重点区域信息

    getPathInfo:'/safetyZone/getPathInfo',//根据围栏id获取重点区域信息

    getVehicleBindInfo:'/safetyZone/getVehicleBindInfo',//根据pathId获取与该重点区域绑定的所有车组车辆相关数据（视图展示）

    bindVehicleToPath:'/safetyZone/bindVehicleToPath',//车组车辆绑定到重点区域

};
